import script from "./BookingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingComponent.vue?vue&type=script&setup=true&lang=js"

import "./BookingComponent.vue?vue&type=style&index=0&id=62594710&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62594710"]])

export default __exports__